<template>
  <div class="input-group mb-3 home-subscribe" :class="hiw?'home-subscribe-wide':'home-subscribe-ib'">
    <b-form @submit="onSubmit">
      <b-input-group class="mt-3">
        <b-form-input
            class="form-control"
            v-model="form.email"
            type="email"
            placeholder="Your email"
        ></b-form-input>
        <div class="input-group-append">
          <b-button class="btn" type="submit" variant="primary">Get Started</b-button>
        </div>
      </b-input-group>
    </b-form>
    <b-button v-if="hiw" to="/how-it-works" class="white-hollow-btn hiw" type="submit" variant="primary">read how it works?</b-button>
  </div>
</template>

<script>
export default {
  name: 'GetStarted',
  props: ['hiw'],
  data()
  {
    return {
      form: {
        email: ''
      }
    }
  },
  created()
  {
    this.form.email = this.$store.getters.email
  },
  methods: {
    onSubmit(evt)
    {
      evt.preventDefault()
      if (this.form.email)
      {
        this.$store.dispatch('updateEmail', this.form.email)
      }
      this.$router.push('/register')
    }
  }
}
</script>

<style lang="scss" scoped>
.home-subscribe-ib{
  display: inline-block;
}

.home-subscribe {
  max-width: 420px;
  text-align: center;
  margin: 24px auto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;

  .form-control {
    background: #FFFFFF;
    border: 2px solid #DFE1E6;
    box-sizing: border-box;
    border-radius: 24px 0 0 24px;
    height: 48px;
  }

  .btn {
    background: #30A7FE;
    border-radius: 0 24px 24px 0;
    color: #FFFFFF;
  }
}

.home-subscribe-wide {
  max-width: 566px;

  .hiw {
    margin-left: 62px;
    margin-top: 15px;
    height: 48px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    padding: 0.65rem 0.65rem !important;
  }
}

@media only screen and (max-width: 1024px) {
  .home-subscribe-wide {
    text-align: center;
    display: inline-flex;
    .hiw {
      margin-left: 8px;
    }
  }
}
@media only screen and (max-width: 585px) {
  form, .mt-3,.hiw {
    width: 100% !important;
  }
}
</style>
